// localStorage side of the review gate for the v3 flow: the pure ack logic already lives in
// components/calculator/review-gate.ts (shared with v2, key `clay-value-review-ack-v1`); this adds
// the try/catch storage wrappers it deliberately leaves to the caller.

import { readStoredString } from '../../../../_shared/read-stored-json';
import { REVIEW_ACK_KEY, hasAckedReview, withReviewAck } from '../../calculator/review-gate';

function readRaw(): string | null {
  // storage unavailable reads as null: the gate shows again, the safe direction
  return readStoredString(localStorage, REVIEW_ACK_KEY);
}

/** Does this deal still need its once-per-deal review warning? A null deal id (demo / unlinked) always does. */
export function reviewGateNeeded(dealId: string | null): boolean {
  return !hasAckedReview(readRaw(), dealId);
}

/** Record the acknowledgement. A null deal id stores nothing, so a throwaway demo never silences a real deal. */
export function ackReviewGate(dealId: string | null): void {
  if (!dealId) return;
  try {
    localStorage.setItem(REVIEW_ACK_KEY, withReviewAck(readRaw(), dealId));
  } catch {
    /* best-effort: failing to store only means the warning shows again */
  }
}
